import React, { Component } from 'react';
import PlacesAutoComplete from 'Components/PlacesAutoComplete';
import { ReactComponent as AddIcon } from "Icons/new-plus.svg";
import { ReactComponent as DeleteIcon } from "Icons/delete.svg";
import { ReactComponent as CancelIcon } from "Icons/cancel-theme.svg";
import Input from 'Components/Input';
import Dropdown from 'Components/Dropdown/dropdown';
import Cx from 'classnames';
import ResponsiveTable from 'Components/ResponsiveTable/index';
import { TAT_UNITS } from 'Constants/commonConstants';
import EmamiDedicatedContract from './emamidedicatedContract';
import { isEmami, isGreenPly, isSapDPL } from 'Utils/index';
import DPLDedicatedContract from './dplDedicatedContract';

const DROP_POINTS = [
    { name: 'Pick-Up', value: 1 },
    { name: 'Drop', value: 2 }
]


class DedicatedContracts extends Component {
    constructor() {
        super();
        this.state = {

        }
    }

    renderTripsOrSearchedTrips=()=>{
        const { trips,searchText,searchedSecondaryCotractRfqTrips} = this.props;
        if(!!searchText){
            return searchedSecondaryCotractRfqTrips;
        }
        return trips;   
    }

    shouldrenderSearchTrips = () => {
        const C1 = isEmami();
        const C2 = isGreenPly()
        if(C1 || C2){
            return false
        }
        return true
    }

    render() {
        const { trips, onChangeTrips, onChangeTripsTouchPoints, vehicleTypes, isView, isEdit, pricingBasis, onChangeDedicatedVC, onAddTrip, onDeleteTrip,searchText,searchedSecondaryCotractRfqTrips } = this.props;
        var symbolsArr = ["e", "E", "+", "-", "."];
        return(
            <>
            <div className={'flex flex-between mt-30'}>
                <div className={'flex'}>
                    <div className='fs-20 header-color fSemibold mt-10'>Record Details</div>
                {this.shouldrenderSearchTrips() && <input placeholder={"Search Trips"} 
                                    type="text" 
                                    className="mr-30 wt-200 br-20 ml-30 ht-40 bg-gray search"
                                    value={searchText}
                                    onChange={this.props.onSearchTrip}
                                />}
                </div>
                <div className={Cx('flex flex-between mt-10', {'disable-pointer-events': isView})}>
                    {!isView && <button className='fs-18 wt-200 ht-40 fSemibold bg-dblue white-color' onClick={() => onAddTrip()}>Add New Record</button>}
                </div>
            </div>
            {(this.renderTripsOrSearchedTrips() || []).map((trip, tripIndex) => { 
              
                const stop = (trip.stops || []);
                const tripId = trip.trip_id;
            return(
            <div className={'mt-20 ht-90 pv-20 ph-20 bg-white br-5 lcl-contract-trips'} style={{'border': '1px solid #85919E'}}>
                {(this.renderTripsOrSearchedTrips() || []).length > 1 && <CancelIcon  className='wt-30 ht-30 pa curP' style={{ 'right': '25px', 'marginTop': '-34px'}} onClick={() => onDeleteTrip(tripIndex)}/>}
                {(isEmami() || isSapDPL() || isGreenPly()) ?
                    <>
                        {(isEmami() || isGreenPly()) && <EmamiDedicatedContract 
                            trip={trip}
                            onAddDedicatedVC={this.props.onAddDedicatedVC}
                            onDeleteDedicatedVC={this.props.onDeleteDedicatedVC}
                            onChangeDedicatedVC={onChangeDedicatedVC}
                            isView={isView}
                            onChangeTrips={onChangeTrips}
                            tripIndex={tripIndex}
                            vehicleTypes={vehicleTypes}
                            pricingBasis={pricingBasis}
                        />}
                        {
                            isSapDPL() && 
                            <DPLDedicatedContract
                                trip={trip}
                                onAddDedicatedVC={this.props.onAddDedicatedVC}
                                onDeleteDedicatedVC={this.props.onDeleteDedicatedVC}
                                onChangeDedicatedVC={onChangeDedicatedVC}
                                isView={isView}
                                onChangeTrips={onChangeTrips}
                                tripIndex={tripIndex}
                                pricingBasis={pricingBasis}
                            />
                        }
                    </>
                : <>
                    <div className={Cx('flex flex-between', {
                        'disable-pointer-events': isView
                    })}>
                        <div className='content-bgColor pv-5 ph-10 mt-5 br-2 col-2 mr-20'>
                                <table className='trip-table-secondary' cellspacing={'10px'}>
                                    <tr>
                                        <th>Route Code Details</th>
                                        <th>From City <span style={{ color: 'red' }}>*</span></th>
                                        <th>From State <span style={{ color: 'red' }}>*</span></th>
                                        <th>From Zone <span style={{ color: 'red' }}>*</span></th>
                                    </tr>
                                    <tr>
                                    <td>
                                            <Input 
                                                className={'border-dblue br-2'}
                                                placeholder={'Route Code Details '}
                                                value={trip.route_details}
                                                onChange={(e) => onChangeTrips(tripIndex, 'route_details', e)}
                                            />
                                        </td>
                                        <td>
                                            <PlacesAutoComplete  
                                                inputClassName={'border-dblue br-2'}
                                                setLocation={onChangeTrips.bind(this, tripIndex, 'from')}
                                                value={(stop[0] || {}).location || ''}
                                            />
                                        </td>
                                        <td>
                                            <Input 
                                                className={'border-dblue br-2'}
                                                placeholder={'State'}
                                                value={(stop[0] || {}).state}
                                                readOnly={true}
                                            />
                                        </td>
                                        <td>
                                            <Input 
                                                className={'border-dblue br-2'}
                                                placeholder={'Zone'}
                                                value={trip.from_zone}
                                                onChange={(e) => onChangeTrips(tripIndex, 'from_zone', e)}
                                            />
                                        </td>
                                    </tr>
                                </table>
                        </div>
                        <div className='content-bgColor pv-5 ph-10 mt-5 br-2 col-2'>
                            <table className='trip-table-secondary' cellspacing={'10px'}>
                                <tr>
                                    <th>To City <span style={{ color: 'red' }}>*</span></th>
                                    <th>To State <span style={{ color: 'red' }}>*</span></th>
                                    <th>To Zone <span style={{ color: 'red' }}>*</span></th>
                                    <th>Pincode</th>
                                </tr>
                                <tr>
                                    <td>
                                        <PlacesAutoComplete  
                                            inputClassName={'border-dblue br-2'}
                                            setLocation={onChangeTrips.bind(this, tripIndex, 'to')}
                                            value={(stop[1] || {}).location || ''}
                                        />
                                    </td>
                                    <td>
                                        <Input  
                                            className={'border-dblue br-2'}
                                            placeholder={'State'}
                                            value={(stop[1] || {}).state}
                                            readOnly={true}
                                        />
                                    </td>
                                    <td>
                                        <Input  
                                            className={'border-dblue br-2'}
                                            placeholder={'Zone'}
                                            value={trip.to_zone}
                                            onChange={(e) => onChangeTrips(tripIndex, 'to_zone', e)}
                                        />
                                    </td>
                                    <td>
                                        <Input  
                                            type="number"
                                            className={'border-dblue br-2'}
                                            placeholder={'Pincode'}
                                            value={trip.to_pincode}
                                            onKeyDown={e => (symbolsArr.includes(e.key)) && e.preventDefault()}
                                            onChange={(e) => onChangeTrips(tripIndex, 'to_pincode', e)}
                                        />
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <div className='lcl-contract-trips'></div>
                    <div className='mt-20'>
                        <ResponsiveTable>
                            <div className='flex mb-40'>
                                <div className='content-bgColor pv-5 ph-10 mt-5 br-2 mr-20 wt-700 inBlock'>
                                    <table className='trip-table-secondary' cellspacing={'10px'}>
                                        <tr>
                                            <th>Rate (₹) <span style={{ color: 'red' }}>*</span></th>
                                            <th>TAT <span style={{ color: 'red' }}>*</span></th>
                                            <th>Minimum Quantity</th>
                                            <th>Vehicle Type <span style={{ color: 'red' }}>*</span></th>
                                        </tr>
                                        <tr>
                                            <td>
                                                <Input 
                                                    className={'border-dblue br-2 wt-80'}
                                                    placeholder={'Rate'}                                            
                                                    value={trip.qbr}
                                                    onKeyDown={e => (["e", "E", "+", "-"].includes(e.key)) && e.preventDefault()}
                                                    onChange={(e) => onChangeTrips(tripIndex, 'qbr', e)}
                                                    type={'number'}
                                                />
                                            </td>
                                            <td className={Cx('', {'disable-pointer-events': isView})}>
                                                <div className='flex'>
                                                    <Input  
                                                        className={'border-dblue br-2 wt-100 mr-5'}
                                                        type={'number'}
                                                        placeholder={'TAT'}
                                                        value={(trip.tat || {}).value}
                                                        onKeyDown={e => (symbolsArr.includes(e.key)) && e.preventDefault()}
                                                        onChange={(e) => onChangeTrips(tripIndex, 'tat', {
                                                            "unit": (trip.tat || {}).unit,
                                                            "value": +e.target.value,
                                                            "name": (trip.tat || {}).name
                                                        })
                                                        }
                                                    />
                                                    <Dropdown 
                                                        items={TAT_UNITS}
                                                        displayKey={"name"}
                                                        // widthValue={'wt-200'}
                                                        className="border-dblue bg-white"
                                                        name="tat_unit" 
                                                        label="Select"
                                                        selectedItem={(trip.tat || {}).unit && TAT_UNITS.find(el => (el.value == ((trip.tat || {}).unit)))}
                                                        onSelect={(optionValue) => onChangeTrips(tripIndex, 'tat', {
                                                            "unit": (TAT_UNITS.find(el => el.name == optionValue) || {}).value,
                                                            "value": (trip.tat || {}).value,
                                                            "name": optionValue
                                                        })
                                                        }
                                                    />
                                                </div>
                                            </td>
                                            <td>
                                                <div className='flex'>
                                                    <Input  
                                                        className={'border-dblue br-2 wt-80 mr-5'}
                                                        type={'number'}
                                                        placeholder={'Quantity'}
                                                        value={trip.minimum_quantity}
                                                        onKeyDown={e => (symbolsArr.includes(e.key)) && e.preventDefault()}
                                                        onChange={(e) => onChangeTrips(tripIndex, 'minimum_quantity', e)}
                                                    />
                                                    <Dropdown 
                                                        items={pricingBasis}
                                                        displayKey={"name"}
                                                        widthValue={'200px'}
                                                        className="border-dblue bg-white"
                                                        name="minimum_quantity_uom" 
                                                        label="Select"
                                                        selectedItem={trip.minimum_quantity_uom && pricingBasis.find(el => el.name == trip.minimum_quantity_uom)}
                                                        onSelect={(optionValue) => onChangeTrips(tripIndex, 'minimum_quantity_uom', optionValue)}
                                                    />
                                                </div>
                                            </td>
                                            <td>
                                                <Dropdown 
                                                    items={vehicleTypes}
                                                    displayKey={"name"}
                                                    widthValue={'300px'}
                                                    className="border-dblue bg-white"
                                                    name="vehicle_type_id" 
                                                    label="Select"
                                                    selectedItem={trip.vehicle_type_id && vehicleTypes.find(el => el.value == trip.vehicle_type_id)}
                                                    onSelect={(optionValue) => onChangeTrips(tripIndex, 'vehicle_type_id', vehicleTypes.find(el => el.name == optionValue))}
                                                />
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <div className='content-bgColor pv-5 ph-10 mt-5 br-2 mr-20 wt-700 inBlock'>
                                    <table className='trip-table-secondary' cellspacing={'10px'}>
                                        <tr>
                                            <th>Variable Cost (₹)</th>
                                            <th>Variable Quantity</th>
                                            {!isView && <th></th>}
                                        </tr>
                                        {(trip.dedicated_variable_cost || []).map((dedicatedCost, dedicatedIndex) => {
                                            return(<tr>
                                                    <td className={Cx('', {'disable-pointer-events': isView})}>
                                                        <Input 
                                                            className={'border-dblue br-2 wt-120'}
                                                            type={'number'}
                                                            placeholder={'Variable Cost'}
                                                            onKeyDown={e => (["e", "E", "+", "-"].includes(e.key)) && e.preventDefault()}
                                                            value={dedicatedCost.variable_cost}
                                                            onChange={(e) => onChangeDedicatedVC(tripIndex, 'variable_cost', e, dedicatedIndex)}
                                                        />
                                                    </td>
                                                    <td className={Cx('', {'disable-pointer-events': isView})}>
                                                        <div className='flex'>
                                                            <Input  
                                                                className={'border-dblue br-2 wt-80 mr-5'}
                                                                type={'number'}
                                                                placeholder={'Quantity'}
                                                                onKeyDown={e => (symbolsArr.includes(e.key)) && e.preventDefault()}
                                                                value={dedicatedCost.variable_quantity}   
                                                                onChange={(e) => onChangeDedicatedVC(tripIndex, 'variable_quantity', e, dedicatedIndex)}
                                                            />
                                                            <Dropdown 
                                                                items={pricingBasis}
                                                                displayKey={"name"}
                                                                widthValue={'200px'}
                                                                className="border-dblue bg-white"
                                                                name="variable_quantity_uom" 
                                                                label="Select"
                                                                selectedItem={dedicatedCost.variable_quantity_uom && pricingBasis.find(el => el.name == dedicatedCost.variable_quantity_uom)}
                                                                onSelect={(optionValue) => onChangeDedicatedVC(tripIndex, 'variable_quantity_uom', optionValue, dedicatedIndex)}                                                       
                                                            />
                                                        </div>
                                                    </td>
                                                    {!isView &&<td>
                                                        <div className='flex'>
                                                            {(trip.dedicated_variable_cost || []).length > 1 && <DeleteIcon className='wt-18 ht-18 mr-5 curP fBold' onClick={() => this.props.onDeleteDedicatedVC(tripIndex, dedicatedIndex)}/>}
                                                            <AddIcon className='curP' onClick={() => this.props.onAddDedicatedVC(tripIndex)}/>
                                                        </div>
                                                    </td>}
                                            </tr>)
                                        })}
                                    </table>
                                </div>
                                <div className='content-bgColor pv-5 ph-10 mt-5 br-2 mr-20 wt-700 inBlock'>
                                    <table className='trip-table-secondary' cellspacing={'10px'}>
                                        <tr>
                                            <th>To City</th>
                                            <th>To State</th>
                                            <th>Point Type</th>
                                            <th>TAT</th>
                                            <th>Pin code</th>
                                            {!isView && <th></th>}
                                        </tr> 
                                        {((trip || {}).touch_points || []).map((el, elIndex) => {
                                            return(<tr>
                                                    <td className={Cx('', {'disable-pointer-events': isView})}>
                                                        <PlacesAutoComplete  
                                                            inputClassName={'border-dblue br-2'}
                                                            setLocation={onChangeTripsTouchPoints.bind(this, elIndex,'from',tripIndex)}
                                                            value={el.location || ''}
                                                        />
                                                    </td>
                                                    <td className={Cx('', {'disable-pointer-events': isView})}>
                                                        <Input 
                                                            className={'border-dblue br-2'}
                                                            placeholder={'State'}
                                                            value={el.state}
                                                            readOnly={true}
                                                        />
                                                    </td>
                                                    <td className={Cx('', {'disable-pointer-events': isView})}>
                                                        <Dropdown 
                                                            items={DROP_POINTS}
                                                            displayKey={"name"}
                                                            className="border-dblue bg-white"
                                                            name="drop_points" 
                                                            label="Select"
                                                            selectedItem={el.point_type && DROP_POINTS.find(dp => dp.value == el.point_type)}
                                                            onSelect={(optionValue) => {
                                                                onChangeTripsTouchPoints(elIndex, 'point_type' , tripIndex, DROP_POINTS.find(dp => dp.name == optionValue));
                                                            }}
                                                        />
                                                    </td>
                                                    <td className={Cx('', {'disable-pointer-events': isView})}>
                                                            <div className='flex'>
                                                                <Input  
                                                                    className={'border-dblue br-2 wt-100 mr-5'}
                                                                    type={'number'}
                                                                    placeholder={'TAT'}
                                                                    value={(el.tat || {}).value}
                                                                    onKeyDown={e => (symbolsArr.includes(e.key)) && e.preventDefault()}
                                                                    onChange={(e) => onChangeTripsTouchPoints(elIndex, 'tat', tripIndex, {
                                                                        "unit": (el.tat || {}).unit,
                                                                        "value": +e.target.value,
                                                                        "name": (el.tat || {}).name
                                                                    })}
                                                                />
                                                                <Dropdown 
                                                                    items={TAT_UNITS}
                                                                    displayKey={"name"}
                                                                    // widthValue={'wt-200'}
                                                                    className="border-dblue bg-white"
                                                                    name="tat_unit" 
                                                                    label="Select"
                                                                    selectedItem={(el.tat || {}).unit && TAT_UNITS.find(ele => (ele.value == ((el.tat || {}).unit)))}
                                                                    onSelect={(optionValue) => onChangeTripsTouchPoints(elIndex, 'tat', tripIndex, {
                                                                        "unit": (TAT_UNITS.find(ele => ele.name == optionValue) || {}).value,
                                                                        "value": (el.tat || {}).value,
                                                                        "name": optionValue
                                                                    })}
                                                                />
                                                            </div>
                                                        </td>
                                                        <td className={Cx('', {'disable-pointer-events': isView})}>
                                                            <Input
                                                                className={'border-dblue br-2'}
                                                                placeholder={'Pincode'}
                                                                value={el.pincode}
                                                                onChange={(e) => onChangeTripsTouchPoints(elIndex, 'pincode', tripIndex, { value: e.target.value })}
                                                            />
                                                        </td>
                                                    {!isView && <td>
                                                        <div className='flex'>
                                                            {((trip || {}).touch_points || []).length > 1 && <DeleteIcon className='wt-18 ht-18 mr-5 curP fBold' onClick={() => this.props.onDeleteTrip(elIndex, true ,tripIndex)}/>}
                                                            <AddIcon  className="curP" onClick={() => this.props.onAddTrip(true, tripIndex)}/>
                                                        </div>
                                                    </td>}
                                            </tr>)
                                        })}
                                    </table>
                                </div>
                            </div>
                        </ResponsiveTable>
                    </div>
                </>}
            </div>)})}
            </>
        )
    }
}

export default DedicatedContracts;